import { Check } from "lucide-react";

/**
 * 5-step workflow bar. Active step highlighted, completed marked with ✓,
 * upcoming grayed. Optional onStepClick (titolare/super_admin only).
 */
const STEPS = [
  { key: "bozza", label: "Bozza", targetStatus: "info_da_richiedere" },
  { key: "lavorazione", label: "Lavorazione", targetStatus: "in_lavorazione" },
  { key: "approvazione", label: "Approvazione", targetStatus: "in_attesa_approvazione" },
  { key: "inviata", label: "Inviata", targetStatus: "inviata" },
  { key: "esito", label: "Esito", targetStatus: "vinta" },
];

const STATUS_TO_STEP_INDEX = {
  info_da_richiedere: 0,
  in_lavorazione: 1,
  in_attesa_approvazione: 2,
  approvata: 2,
  inviata: 3,
  vinta: 4,
  persa: 4,
};

export default function StatusStepBar({ status, canEdit, onStepClick }) {
  const activeIdx = STATUS_TO_STEP_INDEX[status] ?? 0;
  const isLost = status === "persa";

  return (
    <ol
      className="flex items-center gap-1 text-[11px]"
      style={{ color: "var(--text-muted)" }}
      data-testid="status-step-bar"
    >
      {STEPS.map((s, i) => {
        const active = i === activeIdx;
        const completed = i < activeIdx;
        const esitoFinal = i === 4 && (status === "vinta" || status === "persa");
        let bg = "transparent";
        let fg = "var(--text-muted)";
        let border = "1px solid var(--border-subtle)";
        if (active) {
          bg = isLost && i === 4 ? "#FEE2E2" : "var(--accent-subtle)";
          fg = isLost && i === 4 ? "#DC2626" : "var(--accent-primary)";
          border = `1px solid ${isLost && i === 4 ? "#DC2626" : "var(--accent-primary)"}`;
        } else if (completed || esitoFinal) {
          bg = "#DCFCE7";
          fg = "#16A34A";
          border = "1px solid transparent";
        }
        const clickable = canEdit && onStepClick;
        return (
          <li
            key={s.key}
            className={`flex items-center gap-1 ${clickable ? "cursor-pointer" : ""}`}
            onClick={clickable ? () => onStepClick(s) : undefined}
            data-testid={`step-${s.key}${active ? "-active" : ""}`}
          >
            <span
              className="flex items-center gap-1 h-6 px-2 rounded-full font-medium whitespace-nowrap"
              style={{ background: bg, color: fg, border }}
              title={`Stato: ${s.label}${clickable ? " — click per cambiare" : ""}`}
            >
              {(completed || esitoFinal) && !active && (
                <Check className="h-2.5 w-2.5" />
              )}
              <span
                className="inline-flex items-center justify-center h-4 w-4 rounded-full text-[9px] font-semibold"
                style={{
                  background: active || completed || esitoFinal ? fg : "var(--bg-subtle)",
                  color: active || completed || esitoFinal ? bg === "transparent" ? "#fff" : bg : "var(--text-muted)",
                }}
              >
                {i + 1}
              </span>
              {s.label}
              {i === 4 && isLost && <span className="ml-0.5">✕</span>}
            </span>
            {i < STEPS.length - 1 && (
              <span
                className="h-px w-3"
                style={{
                  background:
                    completed || (active && i < activeIdx)
                      ? "#16A34A"
                      : "var(--border-subtle)",
                }}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
